<div data-cy="generic-iq-analysis__page">
    <button data-cy="generic-iq-analysis__iq-button-btn" class="iq-button bg-white br-100" (click)="toggleDropdown()">
        <span class="flex align-center justify-btw gap-10">
            <span class="iq-badge">
                <img src="../../../../../../assets/png/iq_analysis_white.png" alt="IQ">
            </span>
            <span class="fs-13">Acties</span>
            <i class="uil uil-arrow-down fs-22"></i>
        </span>
    </button>

    <div class="status-dropdown" *ngIf="showSummaryDropdown">
        <span class="flex align-center gap-20 px-16 py-24">
            <span class="star-badge"><img src="../../../../../../assets/png/star.png" alt="Star"></span>
            <span class="dropdown-title" *ngIf="type==='stakeholders'">Hi {{globals.user.name}}, welke actie kan ik voor je uitvoeren?</span>
            <span class="dropdown-title" *ngIf="type==='contexts'">Hi {{globals.user.name}}, welke actie kan ik voor je uitvoeren?</span>
            <span class="dropdown-title" *ngIf="type==='contactmoments'">Hi {{globals.user.name}}, welke actie kan ik voor je uitvoeren?</span>
        </span>
        <mat-divider></mat-divider>
        <div class="flex justify-btw align-center py-4 d-cursor-hand px-16 py-12" (click)="openSummaryModal()">
            <span class="fw-600" *ngIf="type==='stakeholders'">{{ 'iq.generate_stakeholder_analysis' | transloco }}</span>
            <span class="fw-600" *ngIf="type==='contexts'">{{ 'iq.make_analysis' | transloco }}</span>
            <span class="fw-600" *ngIf="type==='contactmoments'">{{ 'iq.meeting_notes_audio' | transloco }}</span>
            <mat-icon [style.color]="'#2800d2'" class="uil uil-angle-right-b d-text-middle"></mat-icon>
        </div>
    </div>
</div>
